import {DeployRecord} from "./DeployRecord";

export class ServiceInfo {
    id: number;
    appKey: string;
    name: string;
    description: string | null;
    type: string;
    gitUrl: string;
    createTime: Date;
    updateTime: Date;
    currentDeployJobs: DeployRecord[] | null;
}

export enum ServiceType {
    SPRINGBOOT, NODEJS, COCOS
}

export class DeployServerInfo {
    id: number;
    appKey: string;
    instanceId: string;
    instanceName: string;
    internalIp: string;
    deployState: string;
    deployTime: Date;

    getDisplayName(){
        return `${this.instanceName}@${this.internalIp}`;
    }
}